module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/2a70b21aaaed0619bdfcdec91db1ebe8.svg";